module.exports = __webpack_public_path__ + "img/nightBG.c90250d4.png";